import lookups from '@/assets/json/clientLookups.json'
import { useFormStore } from '@/stores/form'

const setOtherAddressFormData = ({ localCityId = '', addressId = '', addressSourceEnum = '' }) => {
  const formStore = useFormStore()
  const {
    addressSourceEnum: { uDBAddresses, lastRequestAddresses },
    addressUserActionEnum: { Add, TemporaryUse }
  } = lookups
  let _localAddressUserActionEnum = TemporaryUse.toString()
  if ([uDBAddresses, lastRequestAddresses].includes(addressSourceEnum)) {
    _localAddressUserActionEnum = Add.toString()
  }
  formStore.form.setValues({
    cityId: localCityId,
    localUserAddressId: addressId,
    localAddressUserActionEnum: _localAddressUserActionEnum,
    localAddressSourceEnum: addressSourceEnum,
    isHaveNewBehaviorLocalAddress: true
  })
}
export default function (address) {
  try {
    setOtherAddressFormData(address)
  } catch (error) {
    console.error('useAddressFormDataAction error: ', error)
  }
}
